import React from 'react';
import { motion } from 'framer-motion';
const cases = [{
  emoji: '✈️',
  title: 'Holidays',
  tone: 'bg-[#FFF6D6]'
}, {
  emoji: '🍻',
  title: 'Nights out',
  tone: 'bg-[#FFEFE0]'
}, {
  emoji: '🏠',
  title: 'Housemates',
  tone: 'bg-[#E8F6EC]'
}, {
  emoji: '🎓',
  title: 'Student houses',
  tone: 'bg-[#EAF0FB]'
}, {
  emoji: '🎉',
  title: 'Weekends away',
  tone: 'bg-[#FBEAF3]'
}, {
  emoji: '🎪',
  title: 'Festivals',
  tone: 'bg-[#F1EAFB]'
}, {
  emoji: '🍽️',
  title: 'Group dinners',
  tone: 'bg-[#FFF6D6]'
}, {
  emoji: '💑',
  title: 'Couples',
  tone: 'bg-[#FBEAEA]'
}, {
  emoji: '⛷️',
  title: 'Ski trips',
  tone: 'bg-[#E6F4F8]'
}];
export function UseCases() {
  return <section className="bg-[#FFFBF2] py-20 lg:py-28" data-id="element-321" data-mp="2mk5xfvhkmjzx">
      <div className="mx-auto max-w-7xl px-6 sm:px-8" data-id="element-322" data-mp="2ihsrp72tqm35">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-80px'
      }} transition={{
        duration: 0.5
      }} className="mb-12 max-w-2xl" data-id="element-323" data-mp="kqzjjkhipfsp">
          <h2 className="text-3xl font-black leading-[1.05] tracking-tight text-kitty-dark md:text-4xl lg:text-5xl" data-id="element-324" data-mp="2rtfsp63gfvqs">
            Whatever you're doing together, put it in the pot.
          </h2>
        </motion.div>

        <motion.ul initial="hidden" whileInView="visible" viewport={{
        once: true,
        margin: '-60px'
      }} variants={{
        hidden: {},
        visible: {
          transition: {
            staggerChildren: 0.04
          }
        }
      }} className="grid grid-cols-2 gap-4 sm:grid-cols-3 lg:grid-cols-3" data-id="element-325" data-mp="2ivc6e7knauxx">
          {cases.map(useCase => <motion.li key={useCase.title} variants={{
          hidden: {
            opacity: 0,
            y: 14
          },
          visible: {
            opacity: 1,
            y: 0,
            transition: {
              duration: 0.35,
              ease: [0.22, 1, 0.36, 1]
            }
          }
        }} className={`${useCase.tone} flex min-h-[140px] flex-col justify-between rounded-3xl p-6 transition-transform duration-150 hover:-translate-y-1 sm:min-h-[170px] sm:p-7`} data-id="element-326" data-mp="31rlrvfxvmnry">
              <span className="text-3xl sm:text-4xl" aria-hidden="true" data-id="element-327" data-mp="8022oksq8ubg">
                {useCase.emoji}
              </span>
              <h3 className="text-lg font-extrabold text-kitty-dark sm:text-xl" data-id="element-328" data-mp="3u6h5yzfmuzvo">
                {useCase.title}
              </h3>
            </motion.li>)}
        </motion.ul>
      </div>
    </section>;
}